// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages----about-module---container---1Z2Hg","received":"src-pages----about-module---received---11L_2","sent":"src-pages----about-module---sent---2c-MV","button":"src-pages----about-module---button---wG0r8","buttonCentre":"src-pages----about-module---buttonCentre---HwWEo"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about.module.scss
// module id = 939
// module chunks = 144251824217401